var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('transition',[_c('div',{ref:"floatingBall",staticClass:"floating-ball-box",style:({
      width: _vm.itemWidth * _vm.dpr + 'px',
      height: _vm.itemHeight * _vm.dpr + 'px',
      left: _vm.left + 'px',
      top: _vm.top + 'px',
    }),on:{"click":_vm.clickFloatingBall}},[_vm._t("default")],2)])}
var staticRenderFns = []

export { render, staticRenderFns }